import { useTranslation } from '@crehana/i18n';
import { useCentralizedProviderData, useMe } from '@crehana/web';
import { clsx } from 'clsx';
import format from 'date-fns/format';
import { enUS, es, ptBR } from 'date-fns/locale';

const getLocale = (languageCode: string) => {
  switch (languageCode) {
    case 'es':
      return es;
    case 'en':
      return enUS;
    case 'pt':
      return ptBR;
    default:
      return es;
  }
};
interface HeadingProps {
  transparent?: boolean;
}

export const Heading = ({ transparent = false }: HeadingProps) => {
  const { t, languageCode } = useTranslation();
  const { me } = useMe();
  const { me: centralizedMe } = useCentralizedProviderData();

  const date = new Date();
  const weekdayRaw = format(date, 'EEEE', { locale: getLocale(languageCode) });
  const day = format(date, 'd', { locale: getLocale(languageCode) });
  const monthRaw = format(date, 'MMMM', { locale: getLocale(languageCode) });
  const year = format(date, 'yyyy', { locale: getLocale(languageCode) });

  // Capitalize first letter of weekday and month
  const weekday = weekdayRaw.charAt(0).toUpperCase() + weekdayRaw.slice(1);
  const month = monthRaw.charAt(0).toUpperCase() + monthRaw.slice(1);

  let today: string;
  if (languageCode === 'en') {
    // English format: "Tuesday, October 13, 2025"
    today = `${weekday}, ${month} ${day}, ${year}`;
  } else {
    // Spanish/Portuguese format: "Martes 13 de Octubre del 2025"
    const de = t('DATE_PREPOSITION_DE');
    const del = t('DATE_PREPOSITION_DEL');
    today = `${weekday} ${day} ${de} ${month} ${del} ${year}`;
  }

  const name = centralizedMe?.user?.fullName || me?.fullName;

  return (
    <section className={clsx(transparent ? '' : 'tw-bg-neutral-light-100')}>
      <p className="tw-text-center tw-flex tw-flex-col tw-items-center tw-gap-1.6">
        <span className="tw-cds-font-body-02-md tw-cds-text-subtle">
          {today}
        </span>
        <span className="tw-cds-font-heading-03">
          {t('GREETINGS', {
            interpolation: {
              name,
            },
          })}
        </span>
      </p>
    </section>
  );
};
